// Shared constants for LeftPanel and LeftPanelMobileContent

export const SKINS = [
  "#d19771",
  "#f2d3c1",
  "#e6c0a8",
  "#d9b39a",
  "#c79a7b",
  "#b57f5f",
  "#9d6649",
  "#7c4f38",
  "#5b3827",
  "#3e251a",
];

export const APPEARANCE_OPTIONS = {
  female: {
    top: [
      { key: "none", label: "None" },
      { key: "shirt", label: "Shirt" },
      { key: "tank", label: "Tank Top" },
      { key: "tankDT", label: "Dark Tides Tank" },
      { key: "bikini_top", label: "Bikini Top" },
    ],
    bottom: [
      { key: "none", label: "None" },
      { key: "tights", label: "Tights" },
      { key: "jeans", label: "Jeans" },
      { key: "shorts", label: "Shorts" },
      { key: "bikini_bottom", label: "Bikini Bottom" },
    ],
    hair: [
      { key: "none", label: "None" },
      { key: "hair_01", label: "Top Knot" },
      { key: "hair_02", label: "Lob Left" },
      { key: "hair_03", label: "Tight Curls" },
    ],
  },

  male: {
    top: [
      { key: "none", label: "None" },
      { key: "tshirt", label: "T-Shirt" },
      { key: "tank", label: "Tank Top" },
      { key: "tankDT", label: "Dark Tides Tank" },
      { key: "shirt", label: "Shirt" },
    ],
    bottom: [
      { key: "none", label: "None" },
      { key: "jeans", label: "Jeans" },
      { key: "shorts", label: "Shorts" },
      { key: "pants", label: "Pants" },
    ],
    // mobile had "Curls Fade"; desktop had "Curl Fade" — unified to mobile version
    hair: [
      { key: "none", label: "None" },
      { key: "hair_01", label: "Hair 01" },
      { key: "hair_02", label: "Hair 02" },
      { key: "hair_03", label: "Curls Fade" },
    ],
  },
};

// Mobile order and hex values used; desktop had "#c7c7c7c" (typo) for gray
export const HAIR_PRESETS = [
  { id: "black", label: "Black", hex: "#29241e" },
  { id: "brown", label: "Brown", hex: "#3b3024" },
  { id: "blonde", label: "Blonde", hex: "#cfa36a" },
  { id: "blondeGray", label: "Blonde Gray", hex: "#9c8d73" },
  { id: "golden", label: "Golden", hex: "#554828" },
  { id: "platinum", label: "Platinum", hex: "#a99c84" },
  { id: "gray", label: "Gray", hex: "#71635a" },
  { id: "red", label: "Auburn", hex: "#7a3d2a" },
];

// grey: mobile "#a3a3a3" chosen (matches BOTTOM_PRESETS.grey); desktop had "#c7c7c7"
export const TOP_PRESETS = [
  { id: "black", label: "Black", hex: "#111111" },
  { id: "white", label: "White", hex: "#f2f2f2" },
  { id: "charcoal", label: "Charcoal", hex: "#2a2a2a" },
  { id: "navy", label: "Navy", hex: "#1f2a44" },
  { id: "olive", label: "Olive", hex: "#3b4a2a" },
  { id: "tan", label: "Tan", hex: "#b08b5a" },
  { id: "red", label: "Red", hex: "#c31818" },
  { id: "grey", label: "Grey", hex: "#a3a3a3" },
];

// mobile version used (includes red; desktop omitted it); grey "#a3a3a3" matching TOP_PRESETS
export const BOTTOM_PRESETS = [
  { id: "black", label: "Black", hex: "#111111" },
  { id: "white", label: "White", hex: "#f2f2f2" },
  { id: "charcoal", label: "Charcoal", hex: "#2a2a2a" },
  { id: "denim", label: "Denim", hex: "#2a3b66" },
  { id: "navy", label: "Navy", hex: "#1f2a44" },
  { id: "olive", label: "Olive", hex: "#3b4a2a" },
  { id: "tan", label: "Tan", hex: "#b08b5a" },
  { id: "red", label: "Red", hex: "#c31818" },
  { id: "grey", label: "Grey", hex: "#a3a3a3" },
];
